import HomeRecentJobs from './HomeRecentJobs.react'

export default HomeRecentJobs
